import requestAxios from '@/utils/request'

export function getListUserApi (params) {
  return requestAxios.get('user', {params})
}

export function createUserApi (data) {
  return requestAxios.post('user', data)
}

export function updateUserApi (params) {
  const id = params.id
  delete params.id
  return requestAxios.put(`user/${id}`, JSON.stringify(params))
}

export function getDetailUserApi (params) {
  return requestAxios.get(`user/${params.id}`)
}

export function deleteUserApi (id) {
  return requestAxios.delete(`user/${id}`)
}

export function changePasswordApi (params) {
  return requestAxios.post(`user/password/change`, JSON.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/user/index.js